import { useEffect } from "react";
import {
  DatePicker,
  InputText,
  InputTextArea,
  SelectField,
} from "../../../components";
import { useFieldArray, useFormContext } from "react-hook-form";
import { GoTrash } from "react-icons/go";
import { useTranslation } from "react-i18next";
import {
  getCauseOptions,
  getComplaintOptions,
  getCustomerActionOptions,
  getProductNameOptions,
  getItemPossessionStatusOptions,
} from "./options";

function DamagedItems() {
  const { control, watch, setValue } = useFormContext();
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "damage",
  });
  useEffect(() => {
    if (fields.length === 0) {
      append({});
    }
    return () => {};
  }, [append, fields]);

  return (
    <>
      <div className="grid gap-y-4">
        {fields.map((_, index) => {
          const productName = watch(`damage.[${index}].product`);
          return (
            <div key={index} className="relative ">
              <div className="flex justify-between items-center mb-2 bg-[#F7F7F7] text-black font-semibold min-h-8 rounded px-2 gap-2 overflow-hidden">
                <p className="">
                  {t("Damage")} {index + 1}
                </p>
                {index > 0 && (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="text-red-500 flex items-center gap-1"
                  >
                    <GoTrash color="#DB3C32" size={18} />
                  </button>
                )}
              </div>
              <div className="grid min-[540px]:grid-cols-2 grid-cols-1 gap-y-3 gap-x-4 mb-3">
                <SelectField
                  className="bg-transparent"
                  label="Product"
                  control={control}
                  name={`damage.[${index}].product`}
                  options={getProductNameOptions()}
                  required
                  placeholder="Product"
                  onChange={() => setValue(`damage.[${index}].complaint`, "")}
                />
                {/* <SelectField
                  className="bg-transparent"
                  label="Model Number"
                  control={control}
                  name={`damage.[${index}].model_number`}
                  options={[
                    {
                      label: "demo 1",
                      value: "demo 1",
                    },
                  ]}
                  required
                  placeholder="Model Number"
                /> */}
                <InputText
                  label="Model Number"
                  control={control}
                  name={`damage.[${index}].model_number`}
                  required
                  placeholder="Model Number"
                />
                <InputText
                  label="Serial number"
                  control={control}
                  required
                  name={`damage.[${index}].serial_number`}
                />
                <SelectField
                  className="bg-transparent"
                  label="Complaint"
                  control={control}
                  name={`damage.[${index}].complaint`}
                  options={getComplaintOptions(productName)}
                  required
                  placeholder="Complaint"
                  disabled={!productName}
                  disabledPlaceholder="Please select Product Name"
                />

                <DatePicker
                  label="Date of Damage/Discovery"
                  control={control}
                  required
                  name={`damage.[${index}].date_of_damage`}
                  placeholder="Date of Damage/Discovery"
                  disableFuture
                />
                <SelectField
                  className="bg-transparent"
                  label="Cause"
                  control={control}
                  name={`damage.[${index}].cause`}
                  options={getCauseOptions()}
                  required
                  placeholder="Cause"
                />
                <SelectField
                  className="bg-transparent"
                  label="Customer Action"
                  control={control}
                  name={`damage.[${index}].customer_action`}
                  options={getCustomerActionOptions()}
                  required
                  placeholder="Customer Action"
                />
                <div className="min-[540px]:col-span-2">
                  <SelectField
                    className="bg-transparent"
                    label="Who currently has possession of the damaged item?"
                    control={control}
                    name={`damage.[${index}].item_possession_status`}
                    options={getItemPossessionStatusOptions()}
                    required
                    placeholder="Who currently has possession of the damaged item?"
                  />
                </div>
                {(watch(`damage.[${index}].item_possession_status`) ===
                  "Retailer" ||
                  watch(`damage.[${index}].item_possession_status`) ===
                    "Nikon") && (
                  <>
                    <InputText
                      label="Service Order Number"
                      control={control}
                      name={`damage.[${index}].service_order_number`}
                    />
                    <InputText
                      label="Reference Number"
                      control={control}
                      name={`damage.[${index}].reference_number`}
                    />
                  </>
                )}
                <div className="min-[540px]:col-span-2">
                  <InputTextArea
                    label="Description"
                    control={control}
                    name={`damage.[${index}].description`}
                    required
                    placeholder="Description"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <button
        type="button"
        onClick={() => append({})}
        className="text-blue-500 text-sm font-medium"
      >
        + {t("Add Damage")}
      </button>
    </>
  );
}

export default DamagedItems;
